module.exports = __webpack_public_path__ + "media/assets/icons/bed-2e65e3482f341c50efedb135bc0ebca4.svg";